export interface IRsyncEnable {
    'module-RSync':boolean
}

export const getDefaultRsyncEnable = ():IRsyncEnable => {
    return {        
        'module-RSync':false
    }
} 